import Vue from "vue";
// import router from "../../router";

//set Headers payload
const authHeader = process.env.VUE_APP_REQUEST_HEADER;
const headers = {};
headers[authHeader] = process.env.VUE_APP_HUB_API_KEY;

export default {
  namespaced: true,
  state: () => ({
    loadingUsers: false,
    users: [],
    loadingSelectUsers: false,
    selectUsers: [],
    loadingAgentMonthlyAggregate: false,
    loadingAgentAnnualAggregate: false,
    loadingConfiguratorCalledAggregate: false,
    agentsMonthlyAggregates: [],
    agentsAnnualAggregates: [],
    agentsconfiguratorCalledAggregates: [],
    salesAgents: [],
    loadingFenceStatsUsers: false,
    fenceStatsUsers: [
      { "id_user": 11, "username": "Sebastian Petculescu", "zona": "orange", "rol": "superuser" },
      { "id_user": 21, "username": "Alexandru Pietrariu",  "zona": "blue",   "rol": "agent" },
      { "id_user": 7,  "username": "Silvia Fecioru",       "zona": "green",  "rol": "agent" },
      { "id_user": 35, "username": "Adrian Hailemas",      "zona": "violet", "rol": "agent" },
    ],
  }),
  getters: {
    getAgentMonthlyAggregate: (state) => (id) => {
      const agentAgg = state.agentsMonthlyAggregates.find(item => item.user_id == id)
      if (agentAgg) {
        return agentAgg
      }
    },
    getAgentAnnualAggregate: (state) => (id) => {
      const agentAgg = state.agentsAnnualAggregates.find(item => item.user_id == id)
      if (agentAgg) {
        return agentAgg
      }
    },
    getAllAgentsAggregate: (state) => {
      return state.agentsMonthlyAggregates.reduce((accumulator, item) => accumulator + Number(item.aggregate), 0);
    },
    getAllAgentsTotals: (state) => {
      return state.agentsMonthlyAggregates.reduce((accumulator, item) => accumulator + Number(item.total), 0);
    },
    getAgentConfiguratorCalledAggregate: (state) => (payload) => {
      const agentAgg = state.agentsconfiguratorCalledAggregates.find(item => item.called_user_id == payload.id && item.zone_category == payload.zone)
      if (agentAgg) {
        return agentAgg
      }
    },
    getAllConfiguratorCalledAggregatesByZone: (state) => (zone) => {
      const zoneAgg = state.agentsconfiguratorCalledAggregates.filter(item => item.zone_category == zone)
      return zoneAgg.reduce((accumulator, item) => accumulator + Number(item.called_cereri), 0);
    } 
  },
  mutations: {
    setLoadingUsers(state, item) {
      state.loadingUsers = item
    },
    loadUsers(state, items) {
      state.users = items
    },
    setLoadingSelectUsers(state, item) {
      state.loadingSelectUsers = item
    },
    loadUsersSelect(state, items) {
      state.selectUsers = items
    },
    setLoadingAgentAggregate(state, payload) {
      if (payload.type == 'monthly') {
        state.loadingAgentMonthlyAggregate = payload.value
      } else if (payload.type == 'annual') {
        state.loadingAgentAnnualAggregate = payload.value
      }
    },
    setLoadingConfiguratorCalledAggregate(state, value) {
      state.loadingConfiguratorCalledAggregate = value
    },
    loadAgentAggregates(state, payload) {
      if (payload.type == 'monthly') {
        state.agentsMonthlyAggregates = []
        payload.value.forEach(item => {
          state.agentsMonthlyAggregates.push({ ...item })
        });
        // state.agentMonthlyAggregate = payload.value
      } else if (payload.type == 'annual') {
        state.agentsAnnualAggregates = []
        payload.value.forEach(item => {
          state.agentsAnnualAggregates.push({ ...item })
        });
        // state.agentAnnualAggregate = payload.value
      }
    },
    loadAgentConfiguratorCalledAggregates(state, payload) {
      state.agentsconfiguratorCalledAggregates = []
      payload.forEach(item => {
        state.agentsconfiguratorCalledAggregates.push({ ...item })
      });
    },
    setFenceStatsUsers(state, users) { state.fenceStatsUsers = users; },
    setLoadingFenceStatsUsers(state, val) { state.loadingFenceStatsUsers = val; },
  },
  actions: {
    fetchUsers({ commit }, payload) {
      commit("setLoadingUsers", true);

      const qParams = {}

      if (payload.role) {
        qParams.role = payload.role
      }

      if (payload.department) {
        qParams.department = payload.department
      }

      Vue.http
        .get(process.env.VUE_APP_HUB_API_HOST + "api/users", {
          headers: headers,
          params: qParams
        })
        .then(response => {
          commit("loadUsers", response.body);
          commit("setLoadingUsers", false);
        })
        .catch(error => {
          console.log(error);
          commit("setLoadingUsers", false);
        });
    },
    fetchUsersByDepartment({ commit }, department) {
      commit("setLoadingSelectUsers", true);
      Vue.http
        .get(process.env.VUE_APP_HUB_API_HOST + "api/users/department/" + department, {
          headers: headers
        })
        .then(response => {
          commit("loadUsersSelect", response.body);
          commit("setLoadingSelectUsers", false);
        })
        .catch(error => {
          console.log(error);
          commit("setLoadingSelectUsers", false);
        });
    },
    async fetchUsersAggregates({ state, commit }, payload) {
      commit("setLoadingAgentAggregate", { type: payload.interval, value: true });
      let users = state.fenceStatsUsers.map(item => item.id_user);

      let url = "";
      if (payload.department == 'productie') {
        url += "api/productie/aggregate/user/"
      } else if (payload.department == 'vanzari') {
        url += "api/vanzari/aggregate/user/"
      }

      await Vue.http
        .get(process.env.VUE_APP_HUB_API_HOST + url + payload.date1 + "/" + payload.date2, {
          headers: headers,
          params: {
            users: users
          }
        })
        .then(response => {
          commit("loadAgentAggregates", { type: payload.interval, value: response.body });
          commit("setLoadingAgentAggregate", { type: payload.interval, value: false });
        })
        .catch(error => {
          console.log(error);
          commit("setLoadingAgentAggregate", { type: payload.interval, value: false });
        });
    },
    async fetchFenceAgents({ commit }) {
      commit('setLoadingFenceStatsUsers', true);
      await Vue.http
        .get(process.env.VUE_APP_HUB_API_HOST + 'api/reports/fence/agents', { headers })
        .then(response => {
          commit('setFenceStatsUsers', response.body);
          commit('setLoadingFenceStatsUsers', false);
        })
        .catch(error => {
          console.error(error.body?.message);
          commit('setLoadingFenceStatsUsers', false);
        });
    },
    async fetchUsersConfiguratorCalledAggregates({ state, commit }, payload) {
      commit('setLoadingConfiguratorCalledAggregate', true)
      let users = state.fenceStatsUsers.map(item => item.id_user);

      const url = "api/productie/oferte/configurator-gard/aggregate/called/range/"


      await Vue.http
        .get(process.env.VUE_APP_HUB_API_HOST + url + payload.date1 + "/" + payload.date2, {
          headers: headers,
          params: {
            users: users
          }
        })
        .then(response => {
          commit("loadAgentConfiguratorCalledAggregates", response.body );
          commit('setLoadingConfiguratorCalledAggregate', false)
        })
        .catch(error => {
          console.log(error);
          commit('setLoadingConfiguratorCalledAggregate', false)
        });

    }
  }
};
